import React, { useEffect, useState } from "react";

import {
  Badge,
  Container,
  Nav,
  Navbar,
  Dropdown,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaAddressBook,
} from "react-icons/fa";
import logo from "../Assets/Images/logo.png";
import logoHindi from "../Assets/Images/logohindi.png";
import { Link } from "react-router-dom";
import { ApplicationContext } from "../Context/AppContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCompany_Info } from "./../Services/client";
import "../css/footer.css";

const Footer = ({ scrollToSection, aboutusRef, contactusRef }) => {
  const [companyInfo, setCompanyInfo] = useState({});
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getCompanyInfo();
  }, [localStorage.getItem("i18nextLng")]);

  const handleAboutUsClick = () => {
    if (location.pathname === "/") {
      scrollToSection(aboutusRef);
    } else {
      //navigate("/#aboutus");
      navigate("/", { state: { scrollTo: "aboutus" } });
    }
  };

  const viewAllProducts = () => {
    navigate("/products", {
      state: { categoryId: 0 },
    });
  };

  const getCompanyInfo = async () => {
    const lng = localStorage.getItem("i18nextLng");
    if (lng !== "en" && lng !== "hi") {
      i18n.changeLanguage("en");
    }
    const companyInfo = await getCompany_Info(lng);
    if (companyInfo?.data?.data?.length && companyInfo.status === 200) {
      setCompanyInfo(companyInfo.data.data);
    }
  };

  return (
    <footer
      className="text-light"
      style={{ backgroundColor: "#0a4c36", padding: "12px 0" }}
    >
      <Container>
        <Row className="align-items-center">
          <Col md={5} className="footer-col text-center text-md-start">
            <img
              src={i18n.language === "hi" ? logoHindi : logo}
              alt={t("company_logo")}
              width="300"
            />
            {/* <span className="fw-bold fs-3 pt-3 company-name-white">
              {companyInfo?.[0]?.companyname}
            </span> */}
          </Col>

          <Col
            md={4}
            className="footer-col footer-links text-center text-md-start footer-font"
          >
            <h4 className="footer-title">{t("links")}</h4>

            <Nav className="footer-nav">
              <Nav.Link href="/" className="footer-link">
                {t("home")}
              </Nav.Link>
              <Nav.Link
                onClick={() => handleAboutUsClick()}
                className="footer-link"
              >
                {t("aboutus")}
              </Nav.Link>
              <Nav.Link
                onClick={() => viewAllProducts()}
                className="footer-link"
              >
                {t("seeds")}
              </Nav.Link>
            </Nav>
          </Col>

          <Col md={3} className="footer-col text-center footer-font">
            <h4 className="footer-title" ref={contactusRef}>
              {t("contactus")}
            </h4>

            <p className="fs-6 fw-semibold mb-1">
              {companyInfo?.[0]?.companyname}
            </p>

            <p className="footer-text">
              <FaPhone /> {companyInfo?.[0]?.phone1}
            </p>

            <p className="footer-text">
              <FaEnvelope /> {companyInfo?.[0]?.email}
            </p>

            <p className="footer-text">
              <FaMapMarkerAlt /> {t(companyInfo?.[0]?.address1)}
              <span>{t(companyInfo?.[0]?.address2)}</span>
            </p>
            <p>
              <span style={{ marginRight: "10px" }}>
                {companyInfo?.[0]?.pincode}
              </span>
            </p>
          </Col>
        </Row>

        <hr className="bg-light my-2" />
        <Row>
          <Col className="text-center">
            {/* <p className="mb-0">
              © {new Date().getFullYear()} Created by{" "}
              <strong>Soft Solutions</strong>.
            </p> */}
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
